export const UPDATE_TABLE='UPDATE_TABLE'
export const UPDATE_TABLE_SUCCESS= 'UPDATE_TABLE_SUCCESS'
export const UPDATE_TABLE_ERROR= 'UPDATE_TABLE_ERROR'

export const UpdateTable= (data) => ({
    type: UPDATE_TABLE,
    payload: data
});